__turbopack_context__.v({
  "image": "StructuredModuleRenderer-module-scss-module__TCY_4G__image",
  "imageContent": "StructuredModuleRenderer-module-scss-module__TCY_4G__imageContent",
  "report-event-wrapper": "StructuredModuleRenderer-module-scss-module__TCY_4G__report-event-wrapper",
  "structuredContent": "StructuredModuleRenderer-module-scss-module__TCY_4G__structuredContent",
  "text": "StructuredModuleRenderer-module-scss-module__TCY_4G__text",
  "video": "StructuredModuleRenderer-module-scss-module__TCY_4G__video",
});
